export default function fetchAdapter({ url = '', config = {} }) {
  return fetch(url, config)
    .then((response) => response.json())
    .then((data) => data)
    .catch((e) => new Error(e));
}
